import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-black py-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <Link
            to="/"
            onClick={scrollToTop}
            className="text-cream text-xl font-bold cursor-pointer"
          >
            The Real Problem Company
          </Link>

          <div className="text-light-gray text-sm">
            <a
              href="mailto:problems@therealproblemcompany.com"
              className="hover:text-gold transition-colors"
            >
              problems@therealproblemcompany.com
            </a>
          </div>

          <div className="flex items-center gap-6">
            <Link
              to="/contact"
              onClick={scrollToTop}
              className="text-white hover:text-gold transition-colors text-sm font-medium whitespace-nowrap"
            >
              Submit Your Problem
            </Link>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-dark-gray flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-light-gray text-sm">
            © {new Date().getFullYear()} The Real Problem Company. All problems reserved. Solving problems since the dawn of problems.
          </div>

          <div className="flex items-center gap-6">
            <a
              href="https://www.linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-light-gray hover:text-gold transition-colors w-8 h-8 flex items-center justify-center"
            >
              <i className="ri-linkedin-fill text-xl"></i>
            </a>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-light-gray hover:text-gold transition-colors text-sm whitespace-nowrap"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;